export default "__VITE_ASSET__8ca35d67__"